module.exports = __webpack_public_path__ + "static/images/spike01.9e86088.png";